import * as misc from './misc.jsx';
import * as base from './base.jsx';
import * as utils from '../utils.jsx';
import BaseFilter from './baseFilter.jsx';

const shiftStart = 5

class DateFilter extends BaseFilter {
  getDefaultState() {
    var queryParamFilter = this.getThisFiltersDefaultsFromQuery();

    var availableMonths = [];
    var loopMonth = moment().startOf("month");
    var createdDate = moment("2014-10-13 11:00:28.421+02").startOf("month");
    if (window.business) {
      createdDate = moment(business.created).startOf("month");
    }
    while(loopMonth >= createdDate) {
      availableMonths.push({
        value: loopMonth.format(),
        label: loopMonth.format('MMMM YYYY')
      });

      loopMonth = loopMonth.subtract(1, "month");
    }

    var startDate = moment().startOf("day").add(shiftStart, "hours");
    var endDate = moment(startDate).add(1, "day");
    if (queryParamFilter && queryParamFilter[0] && queryParamFilter[1]) {
      startDate = moment(queryParamFilter[0]).startOf("day").add(shiftStart, "hours");
      endDate = moment(queryParamFilter[1]).startOf("day").add(shiftStart, "hours");
    } else {
      if (this.props.startDate) {
        startDate = this.props.startDate;
      }
      if (this.props.endDate) {
        endDate = this.props.endDate;
      }
    }

    if (startDate >= endDate) {
      endDate = moment(startDate).add(1, "day");
    }

    return $.extend(super.getDefaultState(), {
      startDate: startDate,
      endDate: endDate,
      selectedDay: moment(),
      day: false,
      month: false,
      availableMonths: availableMonths,
      selectedMonth: availableMonths[0]
    });
  }

  getFilterClass() {
    var filterClass = this.state.toggled ? "filter date-filter toggled-filter" : "filter date-filter";

    return filterClass;
  }

  getFilterIcon() {
    return
  }

  getFilterBoxIcon() {
    return "icon-calendar"
  }

  startDatePicked(incomingMoment) {
    this.setState(currentState => {
      currentState.startDate = incomingMoment.add(shiftStart, "hours");

      if (currentState.endDate <= currentState.startDate) {
        currentState.endDate = moment(incomingMoment).add(1, "day");
      }

      this.broadcastState(currentState);

      return currentState;
    });
  }

  endDatePicked(incomingMoment) {
    this.setState(currentState => {
      currentState.endDate = incomingMoment.add(shiftStart, "hours");

      if (currentState.endDate <= currentState.startDate) {
        currentState.startDate = moment(incomingMoment).subtract(1, "day");
      }

      this.broadcastState(currentState);

      return currentState;
    });
  }

  setDaySelected() {
    this.dayPicked(this.state.selectedDay, true);
  }

  dayPicked(incomingMoment, wasToggle) {
    if (wasToggle) {
      utils.trackEvent("day_date_toggled", "date_picker");
    } else {
      utils.trackEvent("day_date_picked", "date_picker");
    }

    this.setState(currentState => {
      currentState.selectedDay = incomingMoment.add(shiftStart, "hours");
      currentState.month = false;
      currentState.day = true;
      currentState.startDate = incomingMoment;
      currentState.endDate = moment(incomingMoment).add(1, "day");

      this.broadcastState(currentState);

      return currentState;
    });
  }

  setMonthSelected() {
    this.monthPicked(this.state.selectedMonth, true);
  }

  monthPicked(option, wasToggle) {
    if (wasToggle) {
      utils.trackEvent("month_date_toggled", "date_picker");
    } else {
      utils.trackEvent("month_date_picked", "date_picker");
    }

    this.setState(currentState => {
      currentState.selectedMonth = option;
      currentState.month = true;
      currentState.day = false;
      currentState.startDate = moment(option.value).add(shiftStart, "hours");
      currentState.endDate = moment(option.value).add(1, "month").add(shiftStart, "hours");

      this.broadcastState(currentState);

      return currentState;
    });
  }

  serializeFilter(state) {
    return [state.startDate.format(), state.endDate.format()]
  }

  getSelectedString() {
    return this.state.startDate.format('DD/MM/YYYY') + " to " + this.state.endDate.format('DD/MM/YYYY')
  }

  getOptionButtonClass(key) {
    var className = "option-button";
    if (this.state[key]) {
      className = className + " selected-option-button";
    }

    return className;
  }

  broadcastState(state) {
    radio("filterChanged").broadcast(this.props.filterKey, this.serializeFilter(state));
  }

  getDropdown() {
    return <div className={this.getDropdownClassName() + " date-filter"}>
      <div className="responsive-title">
        Select a date range
      </div>
      <div className="line-item">
        <div
          onClick={this.setDaySelected.bind(this)}
          className="option"
        >
          {this.getOptionButton("day")} Pick a <strong>day</strong>
        </div>
        <misc.CalendarButton
          date={this.state.selectedDay}
          dateChanged={this.dayPicked.bind(this)}
        />
      </div>
      <div className="line-item">
        <div
          onClick={this.setMonthSelected.bind(this)}
          className="option"
        >
          {this.getOptionButton("month")} Pick a <strong>month</strong>
        </div>
        <MonthDropdown
          selectedOption={this.state.selectedMonth}
          options={this.state.availableMonths}
          onChange={this.monthPicked.bind(this)}
        />
      </div>
      <div className="custom-divider">
        <div className="line"></div>
        <div className="text">
        Or select a custom range
        </div>
      </div>
      <div className="date-display">
        <div className="dates">
          <div className="date-end-block">
            <div className="descriptor">
            From {shiftStart}am
            </div>
            <misc.CalendarButton
              date={this.state.startDate}
              dateChanged={this.startDatePicked.bind(this)}
            />
          </div>
          <i className="icon-arrow-right"></i>
          <div className="date-end-block">
            <div className="descriptor">
            until {shiftStart}am
            </div>
            <misc.CalendarButton
              date={this.state.endDate}
              dateChanged={this.endDatePicked.bind(this)}
            />
          </div>
        </div>
      </div>
      <div className="done-button" onClick={this.toggle.bind(this)}>Done</div>
    </div>
  }
}

DateFilter.defaultProps = {
  "filterKey": "created"
}

class MonthDropdown extends base.DismissComponent {
  toggle() {
    this.setState({
      toggled: !this.state.toggled
    });
  }

  optionSelected(option) {
    this.setState({
      toggled: false
    });
    this.props.onChange(option);
  }

  getDropdown() {
    if (this.state.toggled) {
      return <div className="month-dropdown">
      { this.props.options.map(option => {
      var className = "dropdown-option";
      if (this.props.selectedOption.value == option.value) {
      className = className + " picked-option";
      }
        return <div
                 className={className}
                 key={option.value}
               onClick={this.optionSelected.bind(this, option)}>
               <span className="option-label">{option.label}</span>
              </div>
            })}
        </div>
    } else {
      return
    }
  }

  getClassName() {
    var className = "number-select date-select month-select";
    if (this.state.toggled) {
      className = className + " toggled";
    }

    return className;
  }

  render() {
    return <div
      className={this.getClassName()}
      onMouseDown={this.mouseDownHandler.bind(this)}
      onMouseUp={this.mouseUpHandler.bind(this)}>
        <div className="value-display date-value-display" onClick={this.toggle.bind(this)}>
          {this.props.selectedOption.label}
        </div>
        <i className="icon-arrow-65" onClick={this.toggle.bind(this)}></i>
        {this.getDropdown()}
      </div>
    }
}

module.exports = {
  DateFilter: DateFilter
}
